// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__wWD7F","rightAdornment":"Header_rightAdornment__2r6b8"};